var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperExerciseInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M216.5,112.45A14.029,14.029,0,1,1,230.53,98.421,14.045,14.045,0,0,1,216.5,112.45Zm0-27a12.971,12.971,0,1,0,12.971,12.971A12.986,12.986,0,0,0,216.5,85.45Z",
    transform: "translate(-199.502 -81.421)",
    fill: "#635c7c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.789,11.39V7.59H4.825v3.8c0,.817-.146,1.48-.65,1.48s-.681-.663-.681-1.48c0-2.476,0-7.433,0-9.91C3.493.663,3.67,0,4.175,0s.65.662.65,1.479V5.669h6.964V1.479c0-.817.173-1.479.678-1.479s.638.662.638,1.479v9.91c0,.817-.133,1.48-.638,1.48S11.789,12.207,11.789,11.39Zm2.714-.5c-.381,0-.519-.442-.519-.987V2.962c0-.545.138-.985.518-.985h.09c.381,0,.694.441.694.987,0,1.715,0,5.23,0,6.945,0,.545-.313.985-.694.985Zm-12.626,0c-.381,0-.546-.441-.546-.987V2.962c0-.545.274-.985.654-.985h.09c.381,0,.542.441.542.987V9.908c0,.545-.27.985-.651.985ZM15.723,7.909V4.961a.509.509,0,0,1,.395-.494.589.589,0,0,1,.488.494V7.909a.588.588,0,0,1-.488.493A.508.508,0,0,1,15.723,7.909ZM0,7.908c0-.756,0-2.19,0-2.946a.59.59,0,0,1,.488-.494.509.509,0,0,1,.395.494c0,.756,0,2.192,0,2.947A.508.508,0,0,1,.488,8.4.59.59,0,0,1,0,7.908Z",
    transform: "translate(8.573 10.278)",
    fill: "#635c7c"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperExerciseInactiveIcon);
export default __webpack_public_path__ + "static/media/swiper_exercise_inactive_icon.843579f4.svg";
export { ForwardRef as ReactComponent };